import { Injectable } from '@angular/core';
import { Observable, Subject, defer, retry, tap, timer } from 'rxjs';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { DiscussionDetail_WS_Connect } from 'src/app/GlobalVariable';

@Injectable({
    providedIn: 'root',
})
export class DiscussionSignalRService {
    private socket$?: WebSocketSubject<any>;
    private readonly messagesSubject = new Subject<any>();
    public readonly messages$ = this.messagesSubject.asObservable();

    connect(discussionId: number): Observable<any> {
        // No stale BehaviorSubject replay; only live events for this discussion.
        this.close();
        const url = `${DiscussionDetail_WS_Connect}/${discussionId}`;

        return defer(() => {
            const socket = webSocket<any>(url);
            this.socket$ = socket;

            return socket.pipe(
                tap(message => this.messagesSubject.next(message))
            );
        }).pipe(
            retry({
                delay: (_error, retryCount) => {
                    console.warn(`Discussion WebSocket interrupted; retry ${retryCount}`);
                    return timer(Math.min(1000 * retryCount, 10000));
                }
            })
        );
    }

    sendMessage(message: any): void {
        if (this.socket$ && !this.socket$.closed) {
            this.socket$.next(message);
        }
    }

    close(): void {
        const socket = this.socket$;
        this.socket$ = undefined;
        if (socket && !socket.closed) {
            socket.complete();
        }
    }
}
